import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import './index.css'
import App from './App.jsx'
import { DEV_AUTH_BYPASS } from './config'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (DEV_AUTH_BYPASS) {
  console.warn('[toxy] VITE_DEV_AUTH_BYPASS is on: Clerk is skipped (dev server only).')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {DEV_AUTH_BYPASS ? (
      <App />
    ) : (
      <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/login">
        <App />
      </ClerkProvider>
    )}
  </StrictMode>,
)
